import React, { useState } from 'react';
import { Award, X, ChevronLeft, ChevronRight } from 'lucide-react';

const certificates = [
  {
    id: 1,
    title: 'Sertifikat 1',
    image: '/images/certificates/certificates-1.png',
  },
  {
    id: 2,
    title: 'Sertifikat 2',
    image: '/images/certificates/certificates-2.png',
  },
];

const Certificates = () => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const openModal = (certificate) => {
    setSelectedCertificate(certificate);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedCertificate(null);
    document.body.style.overflow = 'auto';
  };

  const navigateCertificate = (direction) => {
    const currentIndex = certificates.findIndex(
      (cert) => cert.id === selectedCertificate.id
    );
    let newIndex;

    if (direction === 'next') {
      newIndex = (currentIndex + 1) % certificates.length;
    } else {
      newIndex = (currentIndex - 1 + certificates.length) % certificates.length;
    }

    setSelectedCertificate(certificates[newIndex]);
  };

  return (
    <section
      id="certificates"
      className="py-16 sm:py-20 md:py-24 lg:py-32 bg-black relative overflow-hidden"
    >
      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#D4AF7A]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#C9A882]/5 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#D4AF7A]/10 border border-[#D4AF7A]/30 rounded-full text-[#D4AF7A] text-sm font-semibold mb-4">
            <Award className="inline-block w-4 h-4 mr-2" />
            Sertifikasi
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#F7F5F2] mb-6 font-display">
            Sertifikat Kami
          </h2>
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-[#D4AF7A]/60"></div>
            <div className="w-2 h-2 rotate-45 bg-[#D4AF7A]"></div>
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-[#D4AF7A]/60"></div>
          </div>
          <p className="text-sm sm:text-base text-[#F7F5F2]/70 max-w-2xl mx-auto lg:text-lg">
            Sertifikat yang telah kami peroleh sebagai bukti kompetensi dan
            profesionalisme
          </p>
        </div>

        {/* Certificates Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {certificates.map((certificate, index) => (
            <div
              key={certificate.id}
              className="group relative overflow-hidden rounded-xl cursor-pointer glass-effect-card card-luxury animate-fade-in-up"
              onClick={() => openModal(certificate)}
              style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'both' }}
            >
              {/* Certificate Preview */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={certificate.image}
                  alt={certificate.title}
                  loading="lazy"
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-[#D4AF7A]/20 rounded-full flex items-center justify-center border border-[#D4AF7A]/50">
                    <Award className="w-8 h-8 text-[#D4AF7A]" />
                  </div>
                  <p className="text-[#F7F5F2] font-medium">
                    Klik untuk melihat
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedCertificate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 animate-fade-in">
          {/* Decorative Elements */}
          <div className="absolute top-20 right-20 w-64 h-64 bg-[#D4AF7A]/8 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-64 h-64 bg-[#C9A882]/6 rounded-full blur-3xl"></div>

          {/* Close Button */}
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 p-3 bg-white/10 hover:bg-[#D4AF7A]/20 border border-[#D4AF7A]/30 rounded-full text-[#F7F5F2] hover:text-[#D4AF7A] hover:scale-110 transition-all duration-300 z-10"
          >
            <X size={24} />
          </button>

          {/* Navigation Buttons */}
          {certificates.length > 1 && (
            <>
              <button
                onClick={() => navigateCertificate('prev')}
                className="absolute left-6 p-3 bg-white/10 hover:bg-[#D4AF7A]/20 border border-[#D4AF7A]/30 rounded-full text-[#F7F5F2] hover:text-[#D4AF7A] hover:scale-110 transition-all duration-300 z-10"
              >
                <ChevronLeft size={24} />
              </button>
              <button
                onClick={() => navigateCertificate('next')}
                className="absolute right-6 p-3 bg-white/10 hover:bg-[#D4AF7A]/20 border border-[#D4AF7A]/30 rounded-full text-[#F7F5F2] hover:text-[#D4AF7A] hover:scale-110 transition-all duration-300 z-10"
              >
                <ChevronRight size={24} />
              </button>
            </>
          )}

          {/* Certificate Image */}
          <div className="max-w-6xl max-h-[90vh] mx-4 animate-fade-scale-in">
            <div className="relative p-1 bg-gradient-to-br from-[#D4AF7A]/30 to-transparent rounded-xl">
              <img
                src={selectedCertificate.image}
                alt={selectedCertificate.title}
                className="max-w-full max-h-[85vh] object-contain rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certificates;
